'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var SpinnerIcon = function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.384615, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.333087, 2.996155) rotate(30.000000) translate(-12.333087, -2.996155) translate(11.333087, 0.996155)",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.395607, 5.331993) rotate(60.000000) translate(-14.395607, -5.331993) translate(13.395607, 3.331993)",
    fillOpacity: "0.84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-0.00262640682",
    y: "0.00673589553",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 8.384615) rotate(90.000000) translate(-15.000000, -8.384615) translate(14.000000, 6.384615)",
    fillOpacity: "0.76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.003845, 11.333087) rotate(120.000000) translate(-14.003845, -11.333087) translate(13.003845, 9.333087)",
    fillOpacity: "0.68"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.666913, 13.388460) rotate(150.000000) translate(-11.666913, -13.388460) translate(10.666913, 11.388460)",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.615385, 14.000000) rotate(180.000000) translate(-8.615385, -14.000000) translate(7.615385, 12.000000)",
    fillOpacity: "0.52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.666913, 13.003845) rotate(-150.000000) translate(-5.666913, -13.003845) translate(4.666913, 11.003845)",
    fillOpacity: "0.44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.611540, 10.666913) rotate(-120.000000) translate(-3.611540, -10.666913) translate(2.611540, 8.666913)",
    fillOpacity: "0.36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 7.615385) rotate(-90.000000) translate(-3.000000, -7.615385) translate(2.000000, 5.615385)",
    fillOpacity: "0.28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.314474, 4.843698) rotate(-60.000000) translate(-3.314474, -4.843698) translate(1.814474, 2.343698)",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.993941209",
    y: "1.00196102",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.333087, 2.611540) rotate(-30.000000) translate(-6.333087, -2.611540) translate(5.333087, 0.611540)",
    fillOpacity: "0.12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  }))))));
};

// See https://github.com/styled-components/babel-plugin-styled-components/issues/216
// @CSS_IMPORT_FIX const css = require('styled-components').css

var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var linkColors = {
  BlueSky: {
    active: 'BlueMoon',
    hover: 'BlueDawn',
    darkHover: 'BlueHeaven'
  },
  Tomato: {
    active: 'TomatoFlash',
    hover: 'TomatoDark',
    darkHover: 'TomatoLight'
  },
  GreyDark: {
    active: 'BlueMoon',
    hover: 'BlueDark'
  },
  White: {
    active: 'Grey',
    hover: 'BlueLight'
  },
  BlueDawn: {
    active: 'Black',
    hover: 'BlueNight'
  }
};
var sizes = {
  sm: {
    fontSize: '1.2rem',
    lineHeight: '1.6rem'
  },
  md: {
    fontSize: '1.4rem',
    lineHeight: '1.8rem'
  },
  lg: {
    fontSize: '1.6rem',
    lineHeight: '2rem'
  },
  xl: {
    fontSize: '1.8rem',
    lineHeight: '2.2rem'
  }
};
var StyledLink = styled.a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-8rbjru-0"
})(["position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color 0.2s ease-in-out,border 0.2s ease-in-out,background-color 0.2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill 0.2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}"], function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
});
var ButtonAsLink = styled.button.withConfig({
  displayName: "Link__ButtonAsLink",
  componentId: "sc-8rbjru-1"
})(["position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color 0.2s ease-in-out,border 0.2s ease-in-out,background-color 0.2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill 0.2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}border:none;text-align:left;", " ", ""], function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return props.kind === 'default' && 'background-color: transparent;';
}, function (props) {
  return !props.disabled && 'cursor: pointer;';
});
var RenderWrapper = styled.span.withConfig({
  displayName: "Link__RenderWrapper",
  componentId: "sc-8rbjru-2"
})(["margin:", ";display:inline-flex;align-items:center;> *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill 0.2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}a{position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color 0.2s ease-in-out,border 0.2s ease-in-out,background-color 0.2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill 0.2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}button{position:relative;max-width:100%;margin:", ";padding:0;line-height:", ";display:inline;font-family:", ";font-size:", ";color:", ";text-decoration:", ";transition:color 0.2s ease-in-out,border 0.2s ease-in-out,background-color 0.2s ease-in-out;word-break:break-word;> *{max-width:100%;}", " &:hover{color:", ";}&:active{color:", ";}", " > *{flex:0 0 auto;}svg{width:", " !important;height:", " !important;vertical-align:text-top;}path,rect{transition:fill 0.2s ease-in-out;fill:", ";}&:hover{path,rect{fill:", ";}}"], function (props) {
  return props.margin;
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return !props.render && props.margin;
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].lineHeight;
}, function (props) {
  return props.inherit ? 'inherit' : getFont(props.theme, props.isSemiBold ? 'semiBold' : 'regular');
}, function (props) {
  return props.inherit || props.size === 'inherit' ? 'inherit' : sizes[props.size] && sizes[props.size].fontSize;
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'underline' : props.underline ? 'underline' : 'none';
}, function (props) {
  return props.kind === 'withBackground' && "padding: ".concat(props.size === 'sm' ? '1.2rem' : props.size === 'md' ? '1.2rem 1.6rem' : '1.2rem 2rem', ";\n      background-color: ").concat(colors.BlueSmoke, ";\n      border-radius: .8rem;\n      max-width: 100%;\n\n      &:hover, &:active {\n        background-color: ").concat(colors.BlueLight, ";\n      }\n    ");
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
}, function (props) {
  return colors[linkColors[props.color].active];
}, function (props) {
  return props.disabled && "\n    &, &:hover {\n      cursor: not-allowed;\n      pointer-events: none;\n      text-decoration: none;\n      color: ".concat(colors.GreyMedium, ";\n      path, rect {\n        fill: ").concat(colors.GreyMedium, ";\n      }\n    }\n  ");
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return calcIconWidth(props.size);
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : colors[Object.keys(linkColors).find(function (color) {
    return color === props.color;
  })];
}, function (props) {
  return props.inherit ? 'inherit' : props.isLoading ? colors[linkColors[props.color].active] : props.theme.dark && colors[linkColors[props.color].darkHover] ? colors[linkColors[props.color].darkHover] : colors[linkColors[props.color].hover];
});
var calcIconWidth = function calcIconWidth(textLinkSize) {
  switch (textLinkSize) {
    case 'sm':
      return '1.6rem';
    case 'md':
      return '2rem';
    case 'lg':
      return '2.4rem';
  }
};
var StyledLoader = styled.div.withConfig({
  displayName: "Link__StyledLoader",
  componentId: "sc-8rbjru-3"
})(["svg{animation:rotate 0.8s steps(12,end) infinite;}@keyframes rotate{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"]);
var RenderedElement = function RenderedElement(props) {
  return props.render ? /*#__PURE__*/React.createElement(RenderWrapper, props) : props.href ? /*#__PURE__*/React.createElement(StyledLink, props) : /*#__PURE__*/React.createElement(ButtonAsLink, _extends({}, props, {
    type: props.type || 'button'
  }));
};
var Link = function Link(props) {
  var id = props.id,
    href = props.href,
    targetBlank = props.targetBlank,
    size = props.size,
    children = props.children,
    onClick = props.onClick,
    iconLeft = props.iconLeft,
    iconRight = props.iconRight,
    inherit = props.inherit,
    kind = props.kind,
    className = props.className,
    underline = props.underline,
    isSemiBold = props.isSemiBold,
    color = props.color,
    isLoading = props.isLoading,
    margin = props.margin,
    disabled = props.disabled,
    render = props.render,
    download = props.download,
    type = props.type,
    form = props.form,
    tabIndex = props.tabIndex;
  var colorAllowed = kind === 'withBackground' ? 'BlueDawn' : color;
  return /*#__PURE__*/React.createElement(RenderedElement, {
    id: id,
    form: form,
    margin: margin,
    size: size,
    className: className,
    inherit: inherit,
    isSemiBold: isSemiBold,
    underline: underline,
    kind: kind,
    iconLeft: iconLeft,
    iconRight: iconRight,
    href: href,
    type: type,
    onClick: disabled ? null : onClick ? function (event) {
      return onClick(event, href, targetBlank);
    } : null,
    target: href && targetBlank ? '_blank' : null,
    rel: href ? targetBlank ? 'noopener noreferrer' : 'noreferrer' : null,
    color: colorAllowed,
    isLoading: isLoading,
    disabled: disabled,
    render: render,
    download: download,
    tabIndex: tabIndex || 0
  }, isLoading && /*#__PURE__*/React.createElement(StyledLoader, {
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(SpinnerIcon, {
    color: colors[colorAllowed],
    isLoading: isLoading
  })), !isLoading && iconLeft, render ? render() : children, !isLoading && iconRight);
};
Link.defaultProps = {
  size: 'md',
  color: 'BlueSky',
  kind: 'default'
};
exports.Link = Link;